import CategoryItem from '../CategoryItem/CategoryItem';
import type * as T from '../types';

import * as S from './layout';

interface Props {
  categories: T.Category[];
}

const CategoryGrid = ({ categories }: Props) => {
  return (
    <S.Container>
      {categories.map(cat => (
        <CategoryItem key={cat.id} category={cat} />
      ))}
    </S.Container>
  );
};

export default CategoryGrid;
